import { styled } from '@mui/material/styles';
import { FirmDocumentFolderCreateDialogInput } from 'pages/Documents/FirmDocuments/components/FirmDocumentFolderCreateDialog/FirmDocumentFolderCreateDialog.styles';

export const FirmDocumentEditDialogFileNameInputShell = styled('div')({
  position: 'relative',
});

export const FirmDocumentEditDialogFileNameInput = styled(FirmDocumentFolderCreateDialogInput, {
  shouldForwardProp: prop => prop !== 'hasExtension' && prop !== 'hasLongExtension',
})<{ hasExtension?: boolean; hasLongExtension?: boolean }>(({ hasExtension = false, hasLongExtension = false, theme }) => ({
  ...(hasExtension ? {
    '&& .MuiOutlinedInput-input': {
      paddingRight: theme.spacing(hasLongExtension ? 11.5 : 8.5),
    },
  } : {}),
}));

export const FirmDocumentEditDialogFileExtension = styled('span', {
  shouldForwardProp: prop => prop !== 'hasLongExtension',
})<{ hasLongExtension?: boolean }>(({ hasLongExtension = false, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.neutral[100],
  border: `var(--dialog-border-width) solid ${theme.palette.neutral[200]}`,
  borderRadius: theme.shape.radius.xs,
  color: theme.palette.neutral[600],
  display: 'inline-flex',
  fontSize: 'var(--dialog-description-font-size)',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 'var(--dialog-description-line-height)',
  maxWidth: theme.spacing(hasLongExtension ? 10 : 7),
  overflow: 'hidden',
  padding: theme.spacing(0.25, 0.75),
  pointerEvents: 'none',
  position: 'absolute',
  right: theme.spacing(1),
  textOverflow: 'ellipsis',
  top: '50%',
  transform: 'translateY(-50%)',
  whiteSpace: 'nowrap',
}));
